import { useQuery, UseQueryOptions } from 'react-query';

import { TRIAL_PAYWALL_QUERY_KEYS } from '../../constants';
import { fetchTrialStatus, TrialStatusResponse } from '../../request';

export const useGetTrialStatus = (
  options?: Omit<
    UseQueryOptions<TrialStatusResponse>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<TrialStatusResponse>(
    [TRIAL_PAYWALL_QUERY_KEYS.STATUS],
    ({ signal }) => fetchTrialStatus(signal),
    {
      enabled: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      ...options,
    }
  );
